import { AudioPlayer } from './audio-player';
import { EventEmitter } from './event-emitter';

export class ImageLoader extends EventEmitter {
	private audioPlayer = AudioPlayer.getInstance();

	protected imageElements = {
		rainFirstFrame: document.querySelector('#rain-first-frame') as HTMLImageElement,
		rainSpritePreload: document.querySelector('#rain-sprite-preload') as HTMLImageElement,
		snowFirstFrame: document.querySelector('#snow-first-frame') as HTMLImageElement,
		snowSpritePreload: document.querySelector('#snow-sprite-preload') as HTMLImageElement,
		// waterWave: document.querySelector('#water-fact-wave') as HTMLImageElement,
		snowFalling: document.querySelector('.snowflakes') as HTMLImageElement,
		rainOverlay: document.querySelector('.rain-overlay') as HTMLImageElement,
		tapGesture: document.querySelector('#tap-gesture') as HTMLImageElement,
		signPost: document.querySelector('#jw-sign') as HTMLImageElement,
	};

	private imageLoadCount = 0;

	public loadImages(): void {
		this.loadIcons();
		this.imageElements.rainFirstFrame.src = '../static/images/sprites/water-drop-first-frame.png';
		this.imageElements.rainSpritePreload.src = '../static/images/sprites/watersplash-spritesheet.png';
		this.imageElements.snowFirstFrame.src = '../static/images/sprites/snowflake-first-frame.png';
		this.imageElements.snowSpritePreload.src = './static/images/sprites/snowdestroy-spritesheet.png';
		// this.imageElements.waterWave.src = './static/images/wave.svg';
		this.imageElements.snowFalling.src = './static/images/snow-falling.gif';
		this.imageElements.rainOverlay.src = './static/images/rain-falling.gif';
		this.imageElements.tapGesture.src = './static/images/hand-action-helper.png';
		this.imageElements.signPost.src = './static/images/just-water-sign.png';
		Object.keys(this.imageElements).forEach((key: string) => {
			(this.imageElements as any)[key].addEventListener('load', this.addToLoadCount.bind(this), { once: true });
		});
	}

	private loadIcons(): void {
		for (let i = 1; i < 13; i++) {
			let numberString = i.toString();
			if (numberString.length === 1) {
				numberString = `0${numberString}`;
			}
			const iconElement = document.querySelector(`#icon-${numberString}`) as HTMLImageElement;
			iconElement.src = `./static/images/fact-icons/${numberString}-jw-icon.svg`;
			iconElement.addEventListener('load', this.addToLoadCount.bind(this), { once: true });
		}
	}

	private addToLoadCount(): void {
		this.imageLoadCount += 1;
		if (this.imageLoadCount === 19) {
			this.finishLoading();
		}
	}

	private finishLoading(): void {
		const loadingSpinner = document.querySelector('#jw-loading') as HTMLElement;
		const startButton = document.querySelector('#start-button') as HTMLElement;
		const experienceContainer = document.querySelector('.experience-container') as HTMLElement;

		loadingSpinner.style.display = 'none';
		startButton.style.display = 'block';
		experienceContainer.style.display = 'block';
		this.listenForStartButtonClick();
	}

	private listenForStartButtonClick(): void {
		const startButton = document.querySelector('#start-button') as HTMLElement;
		const experienceLoading = document.querySelector('.experience-loading') as HTMLElement;
		startButton.addEventListener('click', () => {
			// DO NOT REMOVE
			// This is a small hack to make sure that the audio plays correctly when the phone is on silent
			// Working as of iOS 14.6
			new Audio('../static/audio/silence.mp3').play();

			this.audioPlayer.rain.play();
			this.audioPlayer.bubblePop.play();
			this.audioPlayer.bubblePop.stop();
			this.audioPlayer.iceSwoosh.play();
			this.audioPlayer.iceSwoosh.stop();
			experienceLoading.classList.add('fade-out');
			this.eventEmitter.dispatchEvent(new Event('start'));
			setTimeout(() => {
				experienceLoading.remove();
			}, 1100);
		});
	}
}
